<div class="login-container d-flex justify-content-center align-items-center gap-5">
  <div class="card">
    <img class="logo" draggable="false" src="assets/images/login-registration/hawks-login-logo.png" />
    <div class="text-white font-size-14 text-center login-desc mb-4"
      [innerHTML]="'login.text.description' | translate | markdownTranslate"></div>
    <ng-container>
      <div class="btn-login">
        <fgb-tm-user-login></fgb-tm-user-login>
      </div>
    </ng-container>
  </div>
</div>
<div class="bg-black text-white pb-4">
  <div class="container pt-30">
    <fgbcl-preview />
  </div>
</div>